import React from 'react'
import { UserPlus, Clock, BadgeCheck, UserX } from 'lucide-react';
import { MetricGrid, MetricCard, ActivityChart, C } from './AdminAnalyticsUI';

function AnalyticProfCard({totalCount, xAxisValues, values, rangeLabel}) {
  return (
    <div className='flex flex-col w-full font-plexsans'>
      <MetricGrid cols={4}>
        <MetricCard
          icon={<UserPlus size={16} strokeWidth={2} color={C.navy} />}
          tile="rgba(20,33,61,.06)"
          title="Professional signups"
          value={totalCount?.users}
          desc="New professional accounts created"
        />
        <MetricCard
          icon={<Clock size={16} strokeWidth={2} color={C.brass} />}
          tile="rgba(138,98,49,.1)"
          title="Awaiting approval"
          value={totalCount?.toVerify}
          desc="Profiles submitted for admin review"
        />
        <MetricCard
          icon={<BadgeCheck size={16} strokeWidth={2} color={C.green} />}
          tile="rgba(58,125,79,.1)"
          title="Verified"
          value={totalCount?.verified}
          desc="Signups that are verified"
        />
        <MetricCard
          icon={<UserX size={16} strokeWidth={2} color={C.red} />}
          tile="rgba(154,59,46,.08)"
          title="Unverified"
          value={totalCount?.unverified}
          desc="Signups not yet verified"
        />
      </MetricGrid>
      <ActivityChart
        xAxisValues={xAxisValues}
        rangeLabel={rangeLabel}
        series={[
          { label: 'Signups', color: C.navy, data: values?.users },
          { label: 'Awaiting approval', color: C.brass, data: values?.toVerify },
          { label: 'Verified', color: C.green, data: values?.verified },
          { label: 'Unverified', color: C.red, data: values?.unverified },
        ]}
      />
    </div>
  )
}

export default AnalyticProfCard
